module.exports = {
        srcSet: __webpack_public_path__ + "amenities_mcx_CH-111-91ff4417513b30a9.digested.png"+" 111w",
        images: [{path: __webpack_public_path__ + "amenities_mcx_CH-111-91ff4417513b30a9.digested.png",width: 111,height: 155}],
        src: __webpack_public_path__ + "amenities_mcx_CH-111-91ff4417513b30a9.digested.png",
        toString: function(){return __webpack_public_path__ + "amenities_mcx_CH-111-91ff4417513b30a9.digested.png"},
        
        width: 111,
        height: 155
      }